type BlockquoteProps = {
  dataQa?: string;
  children: React.ReactNode;
};

const Blockquote = ({ children, dataQa }: BlockquoteProps) => (
  <blockquote
    data-test-id={`blockquote-${dataQa}`}
    className='my-8 flex justify-center rounded border border-gray-mid py-3 px-4 align-middle'
  >
    {`"${children}"`}
  </blockquote>
);

export default Blockquote;
